
import { Component, Prop, Vue } from "vue-property-decorator";
import anime from "animejs";
import Button from "@/components/Button.vue";


@Component({
  components: {
    Button
  }
})
export default class Banner extends Vue {
  @Prop() private msg!: string;

  mounted() {
    anime({
      targets: [".less-opacity", ".subtitle", ".description", ".name", "#external"],
      translateY: 200,
      direction: 'reverse',
      duration: 1000,
      color: 'rgba(0, 0, 0, 0)',
      easing: 'easeInOutSine',
      delay: 2000
    });
    anime({
      targets: [".banner-image", ".title"],
      translateX: 1200,
      duration: 1000,
      direction: 'reverse',
      color: 'rgba(0, 0, 0, 0)',
      easing: 'easeInOutSine',
      delay: 2000
    });
    anime({
      targets: '#andysvg path',
      strokeDashoffset: [anime.setDashoffset, 0],
      easing: 'easeInOutQuad',
      duration: 8000,
      direction: 'alternate',
      loop: false,
      delay: 1700
    });
    anime({
      targets: [".triangle-first"],
      translateX: -500,
      direction: 'reverse',
      duration: 1000,
      color: 'rgba(0, 0, 0, 0)',
      easing: 'easeInOutSine',
      delay: 2000
    });
  }
}
